import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-mx-6 w-[calc(100%+32px)] pb-6"
}
const _hoisted_2 = { class: "mx-6 mt-8 border rounded-lg border-neutral-100" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Report Type", -1)
const _hoisted_7 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_8 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Filter", -1)
const _hoisted_10 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Sort", -1)
const _hoisted_12 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_13 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_15 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_16 = { class: "space-y-5" }
const _hoisted_17 = {
  key: 0,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_18 = {
  key: 1,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_19 = {
  key: 2,
  class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap"
}
const _hoisted_20 = { class: "relative group cursor-help" }
const _hoisted_21 = { class: "absolute z-[1] top-5 left-0 w-[800px] rounded group-hover:block hidden whitespace-normal bg-slate-200 p-3" }
const _hoisted_22 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_23 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_24 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_25 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_26 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_27 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_28 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_29 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_30 = { class: "w-full px-6 border-t py-7" }

import { ref, watch, onMounted,computed } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import DataTable from '@/components/partials/DataTable.vue';
import ExportButton from '@/components/buttons/ExportButton.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import LoadingModal from '@/components/modals/LoadingModal.vue';
import { AdjustmentsVerticalIcon, UserGroupIcon, FunnelIcon, ArrowsUpDownIcon } from "@heroicons/vue/24/outline";
import { Popover, PopoverButton, PopoverPanel, Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue';
import ReportService from '@/classes/Reports/ReportService'; 
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import { RoleTypes } from '../../enums/RoleTypes';

import DateFormatter from '@/helpers/DateFormatter';
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import debounce from "lodash/debounce";
import { ReportTypes } from '@/views/enums/ReportTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportCaseRelatedSpecificAge ',
  setup(__props) {

const reportType = ref<string>("Primary Diagnoses");
const showFilter = ref<boolean>(false);
const showSync = ref<boolean>(false);
const loading = ref<boolean>(false);

const enabled = ref<boolean>(false); 
const offices =  ref();

const filters = ref({
    query: null,
    rows: 10,
    created_at: null,
    order: 'asc',
    column: '',
    report_type: ReportTypes.PRIMARY_DIAGNOSIS, 
    page: 1,

    office: null,
    date_registered: null,
})
 
const sortOptions = [
    { id: '1', label: 'Name', value: 'patient'},  
]
const orderOptions = [
    { id: '3', label: 'Ascending', value: 'asc'},
    { id: '4', label: 'Descending', value: 'desc'},
]

const reportTypeOptions = [
    { id: "1", label: "Primary Diagnosis", value: ReportTypes.PRIMARY_DIAGNOSIS },
    // { id: "2", label: "Indigenous Group", value: ReportTypes.INDIGENOUS_GROUP },
    { id: "3", label: "Comorbid VAC/VAW", value: ReportTypes.COMORBIDITY_VAC_VAW },
];
 
const headers  = ref([
    { text:  "Primary Diagnosis"},
    { text: 'Case Number' },
    { text: 'Patient' },
    { text: 'Sex' },
    { text: 'Birthday' },
    { text: 'Age' },
    { text: 'Date Registered' }, 
    { text: 'Assigned Social Worker' }, 
    { text: 'Assigned Physician' }, 
]); 

const paginate = ( page:number, rows:number )=>{
    ReportService.paginate(page, rows,filters.value, fetch)
}

const applyFilters = (search: any = null) => {
    showFilter.value = false;
    paginate( 1, filters.value.rows);
};

const applyReset = () => {
    showFilter.value = false;
    filters.value.created_at = null; 
    paginate( 1, filters.value.rows);
};

const items = ref() 

const fetch = () => { 
    loading.value = true;
    ReportService.index('case-related-specific', omitBy(filters.value, isNil))
        .then(({ data }) => { 
            items.value = data.items 
            offices.value = data.offices  
        })
        .catch(errors => { 
            console.log(errors)
        })
        .finally(() => loading.value = false)
}

const exporting = (): void => {
    loading.value = true;
    ReportService.export('case-related-specific',omitBy(filters.value, isNil))
        .then(({data})=>{ 
             ReportService.downloadExport("case-related-specific-export.csv",data);  
        })
        .finally(() => loading.value = false)
}

const truncateItem = (item:any, strLen:number)=>{
    if(item && item.length > strLen){
        return item.substring(0,strLen) + "..."
    }else{
        return item;
    }
}
const getReportTypeHeader = (type: any)=>{
    reportTypeOptions.filter(function(item:any){
        if(item.value === type){
            headers.value[0].text = item.label; 
        } 
    });
} 

watch(
    () => filters.value.query,
    debounce(() => {
        paginate( 1, filters.value.rows);
        applyReset();
    }, 500)
);
 
watch (
    ()=> filters.value.report_type,
    ()=>{ 
        getReportTypeHeader(filters.value.report_type); 
    }
)

const userRole = ref();
onMounted(()=> { 
    userRole.value =  JSON.parse(localStorage.getItem('user'));
    fetch(); 
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Case Related Reports",
    backLink: "/reports"
  }, {
    lowerRight: _withCtx(() => [
      _createVNode(ExportButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (exporting()))
      })
    ]),
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(DataTable, {
                  hasSearch: true,
                  searchPlaceholder: "Search Report type name, Case No., Patient",
                  headers: headers.value,
                  "no-action": true,
                  count: items.value?.data?.length ?? 0,
                  tableClass: "header-frm-table",
                  dataTableClass: "border-0",
                  search: filters.value.query,
                  "onUpdate:searchText": _cache[14] || (_cache[14] = (value) => (filters.value.query = value))
                }, {
                  topContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(AdjustmentsVerticalIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_6
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createVNode(RadioGroup, {
                                        options: reportTypeOptions,
                                        name: "reportTypeOptions",
                                        modelValue: filters.value.report_type,
                                        "onUpdate:modelValue": [
                                          _cache[1] || (_cache[1] = ($event: any) => ((filters.value.report_type) = $event)),
                                          _cache[2] || (_cache[2] = ($event: any) => (paginate(1, filters.value.rows)))
                                        ],
                                        customLabelClass: "whitespace-nowrap"
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", {
                        class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (showFilter.value = true))
                      }, [
                        _createVNode(_unref(FunnelIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                        _hoisted_9
                      ]),
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_unref(ArrowsUpDownIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_11
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(RadioGroup, {
                                        options: sortOptions,
                                        modelValue: filters.value.column,
                                        "onUpdate:modelValue": [
                                          _cache[4] || (_cache[4] = ($event: any) => ((filters.value.column) = $event)),
                                          _cache[5] || (_cache[5] = ($event: any) => (fetch()))
                                        ],
                                        name: "sortOptions"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_14,
                                    _createElementVNode("div", _hoisted_15, [
                                      _createVNode(RadioGroup, {
                                        options: orderOptions,
                                        modelValue: filters.value.order,
                                        "onUpdate:modelValue": [
                                          _cache[6] || (_cache[6] = ($event: any) => ((filters.value.order) = $event)),
                                          _cache[7] || (_cache[7] = ($event: any) => (fetch()))
                                        ],
                                        name: "orderOptions"
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(FilterPanel, {
                        show: showFilter.value,
                        onClose: _cache[11] || (_cache[11] = ($event: any) => (showFilter.value = false)),
                        "onApply:reset": _cache[12] || (_cache[12] = ($event: any) => (applyReset())),
                        "onApply:filters": _cache[13] || (_cache[13] = ($event: any) => (applyFilters())),
                        customClass: "!overflow-visible overflow-x-visible"
                      }, {
                        fields: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            (userRole.value?.role_id == _unref(RoleTypes).SUPERADMIN || userRole.value?.role_id == _unref(RoleTypes).SUPERADMIN_IT)
                              ? (_openBlock(), _createBlock(DatePicker, {
                                  key: 0,
                                  id: "date_created",
                                  name: "date_created",
                                  label: "Date Created",
                                  modelValue: filters.value.created_at,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.value.created_at) = $event)),
                                  range: "",
                                  multiCalendars: "",
                                  class: "filter-range"
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true),
                            (userRole.value?.role_id == _unref(RoleTypes).SUPERADMIN)
                              ? (_openBlock(), _createBlock(MultiSelect, {
                                  key: 1,
                                  options: offices.value,
                                  id: "office",
                                  name: "office",
                                  label: "Office",
                                  modelValue: filters.value.office,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.value.office) = $event)),
                                  placeholder: "Select.."
                                }, null, 8, ["options", "modelValue"]))
                              : _createCommentVNode("", true),
                            _createVNode(DatePicker, {
                              id: "date_registered",
                              name: "date_registered",
                              label: "Date Registered",
                              modelValue: filters.value.date_registered,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.value.date_registered) = $event)),
                              range: "",
                              multiCalendars: "",
                              class: "filter-range"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["show"])
                    ])
                  ]),
                  body: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
                      return (_openBlock(), _createElementBlock("tr", { key: item }, [
                        (filters.value.report_type == _unref(ReportTypes).INDIGENOUS_GROUP)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(item.indigenous_group), 1))
                          : _createCommentVNode("", true),
                        (filters.value.report_type == _unref(ReportTypes).PRIMARY_DIAGNOSIS)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(item.primary_diagnosis), 1))
                          : _createCommentVNode("", true),
                        (filters.value.report_type == _unref(ReportTypes).COMORBIDITY_VAC_VAW)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                              _createElementVNode("p", _hoisted_20, [
                                _createTextVNode(_toDisplayString(truncateItem(item.comorbid_vac_vaw,15)) + " ", 1),
                                _createElementVNode("span", _hoisted_21, _toDisplayString(item.comorbid_vac_vaw), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(item.case_no), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(item.patient), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(item.gender), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(item.birthdate), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(item.age), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(DateFormatter).customDateFormat(item.created_at, "MMM dd, yyy")), 1),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(item.assigned_social_worker), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(item.assigned_physician), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["headers", "count", "search"]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(SimplePagination, {
                    numRows: filters.value.rows ?? 10,
                    currentPage: items.value?.current_page,
                    "last-page": items.value?.last_page,
                    onUpdate: _cache[15] || (_cache[15] = (value) => paginate(value.page, value.rows))
                  }, null, 8, ["numRows", "currentPage", "last-page"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(LoadingModal, {
        show: loading.value,
        noBtn: "",
        title: "Please wait..",
        content: "System is currently loading the report based on the selected filter."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})